module.exports = __webpack_public_path__ + "assets/img/skype.739b26d7.webp";